import { useState, useEffect } from "react";

import { loadGetEmployeeCode } from "../services/employeeService";

const useGetEmployeeCode = (editPartyID = null) => {

    const [employeeNumber, setEmployeeNumber] = useState([]);
    const [isJobLevelDataLoaded, setIsJobLevelDataLoaded] = useState(false);

    const fetchEmployee = async () => {
        const para = { p_companyid: localStorage.getItem("companyid"), p_modeid: 0, };

        try {
            const data = await loadGetEmployeeCode(para);
            if (data && data.length > 0) {
                setEmployeeNumber(data[0].po_number);
                setIsJobLevelDataLoaded(true);
            }
        } catch (error) {
            console.error("Failed to load employee list:", error);
        }
    };

    useEffect(() => {
        if (!isJobLevelDataLoaded) {
            if (editPartyID === 0) {
                fetchEmployee();
            }
        }
    }, [editPartyID, isJobLevelDataLoaded]);



    return {
        employeeNumber,
        setEmployeeNumber
    };
};

export default useGetEmployeeCode;